/**
 * Convert an ISO 3166-1 alpha-2 country code to its Unicode flag emoji.
 * Returns empty string if the code is missing or malformed.
 */
export function flagEmojiFromCode(code: string | undefined | null): string {
  if (code?.length !== 2) return '';
  const upper = code.toUpperCase();
  // 'A' codepoint is 0x41; ISO alpha-2 codes are A-Z, so we offset each
  // character from 'A' into the Unicode regional-indicator block, which
  // starts at 0x1F1E6 ('A' regional indicator).
  const A = 0x41;
  const REGIONAL_INDICATOR_A = 0x1f1e6;
  // Both indices are guaranteed in-range after the length === 2 check
  // above, so `codePointAt` cannot return undefined here.
  const first = upper.codePointAt(0)!;
  const second = upper.codePointAt(1)!;
  return String.fromCodePoint(
    REGIONAL_INDICATOR_A + (first - A),
    REGIONAL_INDICATOR_A + (second - A),
  );
}
